var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5247 3.58244C29.4113 4.07578 28.2153 4.40911 26.958 4.55978C28.2553 3.7835 29.2259 2.56173 29.6887 1.12244C28.4698 1.84643 27.1358 2.35604 25.7447 2.62911C24.8092 1.63026 23.5701 0.968212 22.2198 0.745742C20.8695 0.523273 19.4835 0.752832 18.277 1.39878C17.0705 2.04473 16.111 3.07093 15.5475 4.31805C14.984 5.56517 14.848 6.96344 15.1607 8.29578C12.6909 8.17177 10.2748 7.52984 8.06923 6.41165C5.86363 5.29346 3.91779 3.72399 2.358 1.80511C1.82467 2.72511 1.518 3.79178 1.518 4.92778C1.51741 5.95044 1.76924 6.95743 2.25117 7.85942C2.7331 8.76141 3.43022 9.53049 4.28067 10.0984C3.29437 10.0671 2.32983 9.80056 1.46733 9.32111V9.40111C1.46723 10.8354 1.96338 12.2256 2.87158 13.3358C3.77978 14.4459 5.0441 15.2077 6.45 15.4918C5.53505 15.7394 4.57578 15.7759 3.64467 15.5984C4.04133 16.8326 4.81399 17.9118 5.85449 18.685C6.89499 19.4582 8.15122 19.8867 9.44733 19.9104C7.24711 21.6377 4.52985 22.5746 1.73267 22.5704C1.23717 22.5706 0.742102 22.5416 0.25 22.4838C3.0893 24.3093 6.39445 25.2782 9.77 25.2744C21.1967 25.2744 27.4433 15.8104 27.4433 7.60244C27.4433 7.33578 27.4367 7.06644 27.4247 6.79978C28.6397 5.92108 29.6885 4.83297 30.522 3.58644L30.5247 3.58244Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.18e9bd2627307be035bafe381bfd51bd.svg";
export { ForwardRef as ReactComponent };